import { DocumentsGroupedControls } from './components/documentsGroupedControls/DocumentsGroupedControls'
import { DocumentsGroupedDetail } from './components/documentsGroupedDetail/DocumentsGroupedDetail'
import { DocumentsGroupedSummary } from './components/documentsGroupedSummary/DocumentsGroupedSummary'
import { useCockpitDocumentsGrouped } from './hooks/useCockpitDocumentsGrouped'
import type { ICockpitDocumentsGroupedProps } from './types'

export const CockpitDocumentsGrouped = ({
  sections,
  readOnly,
  showLinks,
  groupingEnabled = true,
  exportPlan,
  initialDocumentType,
}: ICockpitDocumentsGroupedProps) => {
  const model = useCockpitDocumentsGrouped(sections, readOnly, groupingEnabled, initialDocumentType)
  return (
    <>
      <DocumentsGroupedControls {...model} />
      {model.detail ? (
        <DocumentsGroupedDetail
          group={model.detail}
          grouping={model.grouping}
          documentType={model.documentType}
          readOnly={readOnly}
        />
      ) : (
        <DocumentsGroupedSummary
          exportPlan={model.documentType ? undefined : exportPlan}
          documentType={model.documentType}
          totalCount={model.totalCount}
          rows={model.rows}
          showLinks={!model.documentType}
          linkSections={showLinks ? sections : []}
        />
      )}
    </>
  )
}
